// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_Dialog_overlay__-HvTO","showOverlay":"_Dialog_showOverlay__11NC-","closing":"_Dialog_closing__2NfCn","hideOverlay":"_Dialog_hideOverlay__iU4f-"};